/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  ApprovalQueueGridRequest,
  AvailablePurchaseOrdersResponse,
  BadRequestResponse,
  BillDefaultFormatRequest,
  BillDefaultFormatResponse,
  BillMassPayInfoRequest,
  BillPaymentRequest,
  BillPaymentResponse,
  BillProcessingRequest,
  BillProcessingResponse,
  BillsBulkOcrUploadProcessingStatusGetV2Params,
  BillsDynamicGridResponse,
  BillsExportToAccountingPostV2Params,
  BillsGridPermissionsResponse,
  BillsGridRequest,
  BillTabCountsResponse,
  BillUploadedDetailsResponse,
  BulkBillProcessingStatusResponse,
  BulkBillUploadRequest,
  BulkBillUploadResponse,
  ConflictResponse,
  CostCodeReassignmentResponse,
  DismissDuplicatedBillsRequest,
  EditSplitBillRequest,
  ForbiddenResponse,
  Int32BTServiceListItem,
  MassPayBillsRequest,
  MassPayInfoResponse,
  MassPayOfflineResponse,
  MassPayOnlineResponse,
  MassSendForApprovalRequest,
  MassSendForApprovalResponse,
  MassUpdateApprovalStatusRequest,
  MassUpdateApprovalStatusResponse,
  OnlinePaymentResponseV2,
  PerformingUserTypes,
  ReassignCostCodesRequest,
  ReceiptUploadRequest,
  ReleaseRetainageRequest,
  ReleaseRetainageResponse,
  SaveApRetainageProductServiceRequest,
  SplitBillRequest,
  SplitBillResponse,
  SubPaymentRequest,
  SubPaymentResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2 =
  (
    paidToId: number,
    performingUserType: PerformingUserTypes,
    jobId: number,
    options?: SecondParameter<typeof apixHandler>,
    signal?: AbortSignal,
  ) => {
    return apixHandler<AvailablePurchaseOrdersResponse>(
      {
        url: `/apix/v2/Bills/get-available-purchase-orders/${paidToId}/${performingUserType}/${jobId}`,
        method: "GET",
        signal,
      },
      options,
    );
  };

export const getBillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2QueryKey =
  (
    paidToId?: number,
    performingUserType?: PerformingUserTypes,
    jobId?: number,
  ) => {
    return [
      `/apix/v2/Bills/get-available-purchase-orders/${paidToId}/${performingUserType}/${jobId}`,
    ] as const;
  };

export const getBillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
      >
    >,
    TError = ErrorType<unknown>,
  >(
    paidToId: number,
    performingUserType: PerformingUserTypes,
    jobId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2QueryKey(
        paidToId,
        performingUserType,
        jobId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
        >
      >
    > = ({ signal }) =>
      billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2(
        paidToId,
        performingUserType,
        jobId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(paidToId && performingUserType && jobId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type BillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
      >
    >
  >;
export type BillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2QueryError =
  ErrorType<unknown>;

export function useBillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2<
  TData = Awaited<
    ReturnType<
      typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
    >
  >,
  TError = ErrorType<unknown>,
>(
  paidToId: number,
  performingUserType: PerformingUserTypes,
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof billsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getBillsGetAvailablePurchaseOrdersByPaidToIdAndPerformingUserTypeAndJobIdGetV2QueryOptions(
      paidToId,
      performingUserType,
      jobId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2 = (
  billId: number,
  purchaseOrderId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SubPaymentResponse>(
    {
      url: `/apix/v2/Bills/get-sub-payment-request/${billId}/${purchaseOrderId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getBillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2QueryKey =
  (billId?: number, purchaseOrderId?: number) => {
    return [
      `/apix/v2/Bills/get-sub-payment-request/${billId}/${purchaseOrderId}`,
    ] as const;
  };

export const getBillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2
      >
    >,
    TError = ErrorType<unknown>,
  >(
    billId: number,
    purchaseOrderId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2QueryKey(
        billId,
        purchaseOrderId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2
        >
      >
    > = ({ signal }) =>
      billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2(
        billId,
        purchaseOrderId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(billId && purchaseOrderId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type BillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2
      >
    >
  >;
export type BillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2QueryError =
  ErrorType<unknown>;

export function useBillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2<
  TData = Awaited<
    ReturnType<typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  billId: number,
  purchaseOrderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof billsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getBillsGetSubPaymentRequestByBillIdAndPurchaseOrderIdGetV2QueryOptions(
      billId,
      purchaseOrderId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const billsVendorCreditPaymentsByBillPaymentIdGetV2 = (
  billPaymentId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillPaymentResponse>(
    {
      url: `/apix/v2/Bills/vendor-credit-payments/${billPaymentId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getBillsVendorCreditPaymentsByBillPaymentIdGetV2QueryKey = (
  billPaymentId?: string,
) => {
  return [`/apix/v2/Bills/vendor-credit-payments/${billPaymentId}`] as const;
};

export const getBillsVendorCreditPaymentsByBillPaymentIdGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  billPaymentId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBillsVendorCreditPaymentsByBillPaymentIdGetV2QueryKey(billPaymentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>>
  > = ({ signal }) =>
    billsVendorCreditPaymentsByBillPaymentIdGetV2(
      billPaymentId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!billPaymentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillsVendorCreditPaymentsByBillPaymentIdGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>>
  >;
export type BillsVendorCreditPaymentsByBillPaymentIdGetV2QueryError =
  ErrorType<unknown>;

export function useBillsVendorCreditPaymentsByBillPaymentIdGetV2<
  TData = Awaited<
    ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  billPaymentId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsVendorCreditPaymentsByBillPaymentIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getBillsVendorCreditPaymentsByBillPaymentIdGetV2QueryOptions(
      billPaymentId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsCreateSubPaymentRequestPostV2 = (
  subPaymentRequest: BodyType<SubPaymentRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SubPaymentResponse>(
    {
      url: `/apix/v2/Bills/create-sub-payment-request`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: subPaymentRequest,
      signal,
    },
    options,
  );
};

export const getBillsCreateSubPaymentRequestPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsCreateSubPaymentRequestPostV2>>,
    TError,
    { data: BodyType<SubPaymentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsCreateSubPaymentRequestPostV2>>,
  TError,
  { data: BodyType<SubPaymentRequest> },
  TContext
> => {
  const mutationKey = ["billsCreateSubPaymentRequestPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsCreateSubPaymentRequestPostV2>>,
    { data: BodyType<SubPaymentRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsCreateSubPaymentRequestPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsCreateSubPaymentRequestPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsCreateSubPaymentRequestPostV2>>
>;
export type BillsCreateSubPaymentRequestPostV2MutationBody =
  BodyType<SubPaymentRequest>;
export type BillsCreateSubPaymentRequestPostV2MutationError =
  ErrorType<unknown>;

export const useBillsCreateSubPaymentRequestPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsCreateSubPaymentRequestPostV2>>,
    TError,
    { data: BodyType<SubPaymentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsCreateSubPaymentRequestPostV2>>,
  TError,
  { data: BodyType<SubPaymentRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsCreateSubPaymentRequestPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsUpdateSubPaymentRequestPutV2 = (
  subPaymentRequest: BodyType<SubPaymentRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SubPaymentResponse>(
    {
      url: `/apix/v2/Bills/update-sub-payment-request`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: subPaymentRequest,
    },
    options,
  );
};

export const getBillsUpdateSubPaymentRequestPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsUpdateSubPaymentRequestPutV2>>,
    TError,
    { data: BodyType<SubPaymentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsUpdateSubPaymentRequestPutV2>>,
  TError,
  { data: BodyType<SubPaymentRequest> },
  TContext
> => {
  const mutationKey = ["billsUpdateSubPaymentRequestPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsUpdateSubPaymentRequestPutV2>>,
    { data: BodyType<SubPaymentRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsUpdateSubPaymentRequestPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsUpdateSubPaymentRequestPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsUpdateSubPaymentRequestPutV2>>
>;
export type BillsUpdateSubPaymentRequestPutV2MutationBody =
  BodyType<SubPaymentRequest>;
export type BillsUpdateSubPaymentRequestPutV2MutationError = ErrorType<unknown>;

export const useBillsUpdateSubPaymentRequestPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsUpdateSubPaymentRequestPutV2>>,
    TError,
    { data: BodyType<SubPaymentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsUpdateSubPaymentRequestPutV2>>,
  TError,
  { data: BodyType<SubPaymentRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsUpdateSubPaymentRequestPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsPayOnlinePutV2 = (
  billPaymentRequest: BodyType<BillPaymentRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<OnlinePaymentResponseV2>(
    {
      url: `/apix/v2/Bills/pay-online`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billPaymentRequest,
    },
    options,
  );
};

export const getBillsPayOnlinePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsPayOnlinePutV2>>,
    TError,
    { data: BodyType<BillPaymentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsPayOnlinePutV2>>,
  TError,
  { data: BodyType<BillPaymentRequest> },
  TContext
> => {
  const mutationKey = ["billsPayOnlinePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsPayOnlinePutV2>>,
    { data: BodyType<BillPaymentRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsPayOnlinePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsPayOnlinePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsPayOnlinePutV2>>
>;
export type BillsPayOnlinePutV2MutationBody = BodyType<BillPaymentRequest>;
export type BillsPayOnlinePutV2MutationError = ErrorType<unknown>;

export const useBillsPayOnlinePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsPayOnlinePutV2>>,
    TError,
    { data: BodyType<BillPaymentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsPayOnlinePutV2>>,
  TError,
  { data: BodyType<BillPaymentRequest> },
  TContext
> => {
  const mutationOptions = getBillsPayOnlinePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsOcrUploadPostV2 = (
  receiptUploadRequest: BodyType<ReceiptUploadRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillUploadedDetailsResponse>(
    {
      url: `/apix/v2/Bills/ocr-upload`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: receiptUploadRequest,
      signal,
    },
    options,
  );
};

export const getBillsOcrUploadPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsOcrUploadPostV2>>,
    TError,
    { data: BodyType<ReceiptUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsOcrUploadPostV2>>,
  TError,
  { data: BodyType<ReceiptUploadRequest> },
  TContext
> => {
  const mutationKey = ["billsOcrUploadPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsOcrUploadPostV2>>,
    { data: BodyType<ReceiptUploadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsOcrUploadPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsOcrUploadPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsOcrUploadPostV2>>
>;
export type BillsOcrUploadPostV2MutationBody = BodyType<ReceiptUploadRequest>;
export type BillsOcrUploadPostV2MutationError = ErrorType<unknown>;

export const useBillsOcrUploadPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsOcrUploadPostV2>>,
    TError,
    { data: BodyType<ReceiptUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsOcrUploadPostV2>>,
  TError,
  { data: BodyType<ReceiptUploadRequest> },
  TContext
> => {
  const mutationOptions = getBillsOcrUploadPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsApprovalUsersByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Int32BTServiceListItem[]>(
    { url: `/apix/v2/Bills/approval-users/${jobId}`, method: "GET", signal },
    options,
  );
};

export const getBillsApprovalUsersByJobIdGetV2QueryKey = (jobId?: number) => {
  return [`/apix/v2/Bills/approval-users/${jobId}`] as const;
};

export const getBillsApprovalUsersByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillsApprovalUsersByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>
  > = ({ signal }) =>
    billsApprovalUsersByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillsApprovalUsersByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>
>;
export type BillsApprovalUsersByJobIdGetV2QueryError = ErrorType<unknown>;

export function useBillsApprovalUsersByJobIdGetV2<
  TData = Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsApprovalUsersByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillsApprovalUsersByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsTabCountsPostV2 = (
  billsGridRequest: BodyType<BillsGridRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillTabCountsResponse>(
    {
      url: `/apix/v2/Bills/tab-counts`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billsGridRequest,
      signal,
    },
    options,
  );
};

export const getBillsTabCountsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsTabCountsPostV2>>,
    TError,
    { data: BodyType<BillsGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsTabCountsPostV2>>,
  TError,
  { data: BodyType<BillsGridRequest> },
  TContext
> => {
  const mutationKey = ["billsTabCountsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsTabCountsPostV2>>,
    { data: BodyType<BillsGridRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsTabCountsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsTabCountsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsTabCountsPostV2>>
>;
export type BillsTabCountsPostV2MutationBody = BodyType<BillsGridRequest>;
export type BillsTabCountsPostV2MutationError = ErrorType<unknown>;

export const useBillsTabCountsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsTabCountsPostV2>>,
    TError,
    { data: BodyType<BillsGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsTabCountsPostV2>>,
  TError,
  { data: BodyType<BillsGridRequest> },
  TContext
> => {
  const mutationOptions = getBillsTabCountsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsGridPermissionsPostV2 = (
  billsGridRequest: BodyType<BillsGridRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillsGridPermissionsResponse>(
    {
      url: `/apix/v2/Bills/grid-permissions`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billsGridRequest,
      signal,
    },
    options,
  );
};

export const getBillsGridPermissionsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsGridPermissionsPostV2>>,
    TError,
    { data: BodyType<BillsGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsGridPermissionsPostV2>>,
  TError,
  { data: BodyType<BillsGridRequest> },
  TContext
> => {
  const mutationKey = ["billsGridPermissionsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsGridPermissionsPostV2>>,
    { data: BodyType<BillsGridRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsGridPermissionsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsGridPermissionsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsGridPermissionsPostV2>>
>;
export type BillsGridPermissionsPostV2MutationBody = BodyType<BillsGridRequest>;
export type BillsGridPermissionsPostV2MutationError = ErrorType<unknown>;

export const useBillsGridPermissionsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsGridPermissionsPostV2>>,
    TError,
    { data: BodyType<BillsGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsGridPermissionsPostV2>>,
  TError,
  { data: BodyType<BillsGridRequest> },
  TContext
> => {
  const mutationOptions = getBillsGridPermissionsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsApprovalQueueGridPostV2 = (
  approvalQueueGridRequest: BodyType<ApprovalQueueGridRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillsDynamicGridResponse>(
    {
      url: `/apix/v2/Bills/approval-queue/grid`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: approvalQueueGridRequest,
      signal,
    },
    options,
  );
};

export const getBillsApprovalQueueGridPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsApprovalQueueGridPostV2>>,
    TError,
    { data: BodyType<ApprovalQueueGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsApprovalQueueGridPostV2>>,
  TError,
  { data: BodyType<ApprovalQueueGridRequest> },
  TContext
> => {
  const mutationKey = ["billsApprovalQueueGridPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsApprovalQueueGridPostV2>>,
    { data: BodyType<ApprovalQueueGridRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsApprovalQueueGridPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsApprovalQueueGridPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsApprovalQueueGridPostV2>>
>;
export type BillsApprovalQueueGridPostV2MutationBody =
  BodyType<ApprovalQueueGridRequest>;
export type BillsApprovalQueueGridPostV2MutationError =
  ErrorType<BadRequestResponse>;

export const useBillsApprovalQueueGridPostV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsApprovalQueueGridPostV2>>,
    TError,
    { data: BodyType<ApprovalQueueGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsApprovalQueueGridPostV2>>,
  TError,
  { data: BodyType<ApprovalQueueGridRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsApprovalQueueGridPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsMassPayOnlinePostV2 = (
  massPayBillsRequest: BodyType<MassPayBillsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassPayOnlineResponse>(
    {
      url: `/apix/v2/Bills/mass-pay-online`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massPayBillsRequest,
      signal,
    },
    options,
  );
};

export const getBillsMassPayOnlinePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassPayOnlinePostV2>>,
    TError,
    { data: BodyType<MassPayBillsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsMassPayOnlinePostV2>>,
  TError,
  { data: BodyType<MassPayBillsRequest> },
  TContext
> => {
  const mutationKey = ["billsMassPayOnlinePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsMassPayOnlinePostV2>>,
    { data: BodyType<MassPayBillsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsMassPayOnlinePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsMassPayOnlinePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsMassPayOnlinePostV2>>
>;
export type BillsMassPayOnlinePostV2MutationBody =
  BodyType<MassPayBillsRequest>;
export type BillsMassPayOnlinePostV2MutationError = ErrorType<unknown>;

export const useBillsMassPayOnlinePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassPayOnlinePostV2>>,
    TError,
    { data: BodyType<MassPayBillsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsMassPayOnlinePostV2>>,
  TError,
  { data: BodyType<MassPayBillsRequest> },
  TContext
> => {
  const mutationOptions = getBillsMassPayOnlinePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsMassPayOfflineInfoPostV2 = (
  billMassPayInfoRequest: BodyType<BillMassPayInfoRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassPayInfoResponse>(
    {
      url: `/apix/v2/Bills/mass-pay-offline-info`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billMassPayInfoRequest,
      signal,
    },
    options,
  );
};

export const getBillsMassPayOfflineInfoPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassPayOfflineInfoPostV2>>,
    TError,
    { data: BodyType<BillMassPayInfoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsMassPayOfflineInfoPostV2>>,
  TError,
  { data: BodyType<BillMassPayInfoRequest> },
  TContext
> => {
  const mutationKey = ["billsMassPayOfflineInfoPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsMassPayOfflineInfoPostV2>>,
    { data: BodyType<BillMassPayInfoRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsMassPayOfflineInfoPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsMassPayOfflineInfoPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsMassPayOfflineInfoPostV2>>
>;
export type BillsMassPayOfflineInfoPostV2MutationBody =
  BodyType<BillMassPayInfoRequest>;
export type BillsMassPayOfflineInfoPostV2MutationError = ErrorType<unknown>;

export const useBillsMassPayOfflineInfoPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassPayOfflineInfoPostV2>>,
    TError,
    { data: BodyType<BillMassPayInfoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsMassPayOfflineInfoPostV2>>,
  TError,
  { data: BodyType<BillMassPayInfoRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsMassPayOfflineInfoPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsMassPayOfflinePostV2 = (
  massPayBillsRequest: BodyType<MassPayBillsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassPayOfflineResponse>(
    {
      url: `/apix/v2/Bills/mass-pay-offline`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massPayBillsRequest,
      signal,
    },
    options,
  );
};

export const getBillsMassPayOfflinePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassPayOfflinePostV2>>,
    TError,
    { data: BodyType<MassPayBillsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsMassPayOfflinePostV2>>,
  TError,
  { data: BodyType<MassPayBillsRequest> },
  TContext
> => {
  const mutationKey = ["billsMassPayOfflinePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsMassPayOfflinePostV2>>,
    { data: BodyType<MassPayBillsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsMassPayOfflinePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsMassPayOfflinePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsMassPayOfflinePostV2>>
>;
export type BillsMassPayOfflinePostV2MutationBody =
  BodyType<MassPayBillsRequest>;
export type BillsMassPayOfflinePostV2MutationError = ErrorType<unknown>;

export const useBillsMassPayOfflinePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassPayOfflinePostV2>>,
    TError,
    { data: BodyType<MassPayBillsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsMassPayOfflinePostV2>>,
  TError,
  { data: BodyType<MassPayBillsRequest> },
  TContext
> => {
  const mutationOptions = getBillsMassPayOfflinePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsDismissDuplicatedBillsPostV2 = (
  dismissDuplicatedBillsRequest: BodyType<DismissDuplicatedBillsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Bills/dismiss-duplicated-bills`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: dismissDuplicatedBillsRequest,
      signal,
    },
    options,
  );
};

export const getBillsDismissDuplicatedBillsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsDismissDuplicatedBillsPostV2>>,
    TError,
    { data: BodyType<DismissDuplicatedBillsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsDismissDuplicatedBillsPostV2>>,
  TError,
  { data: BodyType<DismissDuplicatedBillsRequest> },
  TContext
> => {
  const mutationKey = ["billsDismissDuplicatedBillsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsDismissDuplicatedBillsPostV2>>,
    { data: BodyType<DismissDuplicatedBillsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsDismissDuplicatedBillsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsDismissDuplicatedBillsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsDismissDuplicatedBillsPostV2>>
>;
export type BillsDismissDuplicatedBillsPostV2MutationBody =
  BodyType<DismissDuplicatedBillsRequest>;
export type BillsDismissDuplicatedBillsPostV2MutationError = ErrorType<unknown>;

export const useBillsDismissDuplicatedBillsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsDismissDuplicatedBillsPostV2>>,
    TError,
    { data: BodyType<DismissDuplicatedBillsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsDismissDuplicatedBillsPostV2>>,
  TError,
  { data: BodyType<DismissDuplicatedBillsRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsDismissDuplicatedBillsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsBulkOcrUploadPostV2 = (
  bulkBillUploadRequest: BodyType<BulkBillUploadRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BulkBillUploadResponse>(
    {
      url: `/apix/v2/Bills/bulk-ocr-upload`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkBillUploadRequest,
      signal,
    },
    options,
  );
};

export const getBillsBulkOcrUploadPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsBulkOcrUploadPostV2>>,
    TError,
    { data: BodyType<BulkBillUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsBulkOcrUploadPostV2>>,
  TError,
  { data: BodyType<BulkBillUploadRequest> },
  TContext
> => {
  const mutationKey = ["billsBulkOcrUploadPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsBulkOcrUploadPostV2>>,
    { data: BodyType<BulkBillUploadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsBulkOcrUploadPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsBulkOcrUploadPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsBulkOcrUploadPostV2>>
>;
export type BillsBulkOcrUploadPostV2MutationBody =
  BodyType<BulkBillUploadRequest>;
export type BillsBulkOcrUploadPostV2MutationError = ErrorType<unknown>;

export const useBillsBulkOcrUploadPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsBulkOcrUploadPostV2>>,
    TError,
    { data: BodyType<BulkBillUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsBulkOcrUploadPostV2>>,
  TError,
  { data: BodyType<BulkBillUploadRequest> },
  TContext
> => {
  const mutationOptions = getBillsBulkOcrUploadPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsReassignCostCodesPostV2 = (
  reassignCostCodesRequest: BodyType<ReassignCostCodesRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CostCodeReassignmentResponse>(
    {
      url: `/apix/v2/Bills/reassign-cost-codes`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: reassignCostCodesRequest,
      signal,
    },
    options,
  );
};

export const getBillsReassignCostCodesPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsReassignCostCodesPostV2>>,
    TError,
    { data: BodyType<ReassignCostCodesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsReassignCostCodesPostV2>>,
  TError,
  { data: BodyType<ReassignCostCodesRequest> },
  TContext
> => {
  const mutationKey = ["billsReassignCostCodesPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsReassignCostCodesPostV2>>,
    { data: BodyType<ReassignCostCodesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsReassignCostCodesPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsReassignCostCodesPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsReassignCostCodesPostV2>>
>;
export type BillsReassignCostCodesPostV2MutationBody =
  BodyType<ReassignCostCodesRequest>;
export type BillsReassignCostCodesPostV2MutationError = ErrorType<unknown>;

export const useBillsReassignCostCodesPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsReassignCostCodesPostV2>>,
    TError,
    { data: BodyType<ReassignCostCodesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsReassignCostCodesPostV2>>,
  TError,
  { data: BodyType<ReassignCostCodesRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsReassignCostCodesPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsBulkOcrUploadProcessingStatusGetV2 = (
  params?: BillsBulkOcrUploadProcessingStatusGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BulkBillProcessingStatusResponse>(
    {
      url: `/apix/v2/Bills/bulk-ocr-upload/processing-status`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getBillsBulkOcrUploadProcessingStatusGetV2QueryKey = (
  params?: BillsBulkOcrUploadProcessingStatusGetV2Params,
) => {
  return [
    `/apix/v2/Bills/bulk-ocr-upload/processing-status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBillsBulkOcrUploadProcessingStatusGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: BillsBulkOcrUploadProcessingStatusGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBillsBulkOcrUploadProcessingStatusGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>
  > = ({ signal }) =>
    billsBulkOcrUploadProcessingStatusGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillsBulkOcrUploadProcessingStatusGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>
>;
export type BillsBulkOcrUploadProcessingStatusGetV2QueryError =
  ErrorType<unknown>;

export function useBillsBulkOcrUploadProcessingStatusGetV2<
  TData = Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: BillsBulkOcrUploadProcessingStatusGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsBulkOcrUploadProcessingStatusGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillsBulkOcrUploadProcessingStatusGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsExportToAccountingPostV2 = (
  billsGridRequest: BodyType<BillsGridRequest>,
  params?: BillsExportToAccountingPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Bills/export-to-accounting`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billsGridRequest,
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getBillsExportToAccountingPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsExportToAccountingPostV2>>,
    TError,
    {
      data: BodyType<BillsGridRequest>;
      params?: BillsExportToAccountingPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsExportToAccountingPostV2>>,
  TError,
  {
    data: BodyType<BillsGridRequest>;
    params?: BillsExportToAccountingPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["billsExportToAccountingPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsExportToAccountingPostV2>>,
    {
      data: BodyType<BillsGridRequest>;
      params?: BillsExportToAccountingPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return billsExportToAccountingPostV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsExportToAccountingPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsExportToAccountingPostV2>>
>;
export type BillsExportToAccountingPostV2MutationBody =
  BodyType<BillsGridRequest>;
export type BillsExportToAccountingPostV2MutationError = ErrorType<unknown>;

export const useBillsExportToAccountingPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsExportToAccountingPostV2>>,
    TError,
    {
      data: BodyType<BillsGridRequest>;
      params?: BillsExportToAccountingPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsExportToAccountingPostV2>>,
  TError,
  {
    data: BodyType<BillsGridRequest>;
    params?: BillsExportToAccountingPostV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getBillsExportToAccountingPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const billsPreferencesDefaultFormatGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillDefaultFormatResponse>(
    { url: `/apix/v2/Bills/preferences/default-format`, method: "GET", signal },
    options,
  );
};

export const getBillsPreferencesDefaultFormatGetV2QueryKey = () => {
  return [`/apix/v2/Bills/preferences/default-format`] as const;
};

export const getBillsPreferencesDefaultFormatGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillsPreferencesDefaultFormatGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>
  > = ({ signal }) =>
    billsPreferencesDefaultFormatGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillsPreferencesDefaultFormatGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>
>;
export type BillsPreferencesDefaultFormatGetV2QueryError = ErrorType<unknown>;

export function useBillsPreferencesDefaultFormatGetV2<
  TData = Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getBillsPreferencesDefaultFormatGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const billsPreferencesDefaultFormatPutV2 = (
  billDefaultFormatRequest: BodyType<BillDefaultFormatRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Bills/preferences/default-format`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billDefaultFormatRequest,
    },
    options,
  );
};

export const getBillsPreferencesDefaultFormatPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatPutV2>>,
    TError,
    { data: BodyType<BillDefaultFormatRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsPreferencesDefaultFormatPutV2>>,
  TError,
  { data: BodyType<BillDefaultFormatRequest> },
  TContext
> => {
  const mutationKey = ["billsPreferencesDefaultFormatPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatPutV2>>,
    { data: BodyType<BillDefaultFormatRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsPreferencesDefaultFormatPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsPreferencesDefaultFormatPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsPreferencesDefaultFormatPutV2>>
>;
export type BillsPreferencesDefaultFormatPutV2MutationBody =
  BodyType<BillDefaultFormatRequest>;
export type BillsPreferencesDefaultFormatPutV2MutationError =
  ErrorType<unknown>;

export const useBillsPreferencesDefaultFormatPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsPreferencesDefaultFormatPutV2>>,
    TError,
    { data: BodyType<BillDefaultFormatRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsPreferencesDefaultFormatPutV2>>,
  TError,
  { data: BodyType<BillDefaultFormatRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsPreferencesDefaultFormatPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsApRetainageProductServicePutV2 = (
  saveApRetainageProductServiceRequest: BodyType<SaveApRetainageProductServiceRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Bills/ap-retainage-product-service`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: saveApRetainageProductServiceRequest,
    },
    options,
  );
};

export const getBillsApRetainageProductServicePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsApRetainageProductServicePutV2>>,
    TError,
    { data: BodyType<SaveApRetainageProductServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsApRetainageProductServicePutV2>>,
  TError,
  { data: BodyType<SaveApRetainageProductServiceRequest> },
  TContext
> => {
  const mutationKey = ["billsApRetainageProductServicePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsApRetainageProductServicePutV2>>,
    { data: BodyType<SaveApRetainageProductServiceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsApRetainageProductServicePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsApRetainageProductServicePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsApRetainageProductServicePutV2>>
>;
export type BillsApRetainageProductServicePutV2MutationBody =
  BodyType<SaveApRetainageProductServiceRequest>;
export type BillsApRetainageProductServicePutV2MutationError =
  ErrorType<unknown>;

export const useBillsApRetainageProductServicePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsApRetainageProductServicePutV2>>,
    TError,
    { data: BodyType<SaveApRetainageProductServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsApRetainageProductServicePutV2>>,
  TError,
  { data: BodyType<SaveApRetainageProductServiceRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsApRetainageProductServicePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const billsMassUpdateApprovalStatusPutV2 = (
  massUpdateApprovalStatusRequest: BodyType<MassUpdateApprovalStatusRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<MassUpdateApprovalStatusResponse>(
    {
      url: `/apix/v2/Bills/mass-update-approval-status`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massUpdateApprovalStatusRequest,
    },
    options,
  );
};

export const getBillsMassUpdateApprovalStatusPutV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassUpdateApprovalStatusPutV2>>,
    TError,
    { data: BodyType<MassUpdateApprovalStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsMassUpdateApprovalStatusPutV2>>,
  TError,
  { data: BodyType<MassUpdateApprovalStatusRequest> },
  TContext
> => {
  const mutationKey = ["billsMassUpdateApprovalStatusPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsMassUpdateApprovalStatusPutV2>>,
    { data: BodyType<MassUpdateApprovalStatusRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsMassUpdateApprovalStatusPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsMassUpdateApprovalStatusPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsMassUpdateApprovalStatusPutV2>>
>;
export type BillsMassUpdateApprovalStatusPutV2MutationBody =
  BodyType<MassUpdateApprovalStatusRequest>;
export type BillsMassUpdateApprovalStatusPutV2MutationError =
  ErrorType<BadRequestResponse>;

export const useBillsMassUpdateApprovalStatusPutV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassUpdateApprovalStatusPutV2>>,
    TError,
    { data: BodyType<MassUpdateApprovalStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsMassUpdateApprovalStatusPutV2>>,
  TError,
  { data: BodyType<MassUpdateApprovalStatusRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsMassUpdateApprovalStatusPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const billsMassSendForApprovalPutV2 = (
  massSendForApprovalRequest: BodyType<MassSendForApprovalRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<MassSendForApprovalResponse>(
    {
      url: `/apix/v2/Bills/mass-send-for-approval`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massSendForApprovalRequest,
    },
    options,
  );
};

export const getBillsMassSendForApprovalPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassSendForApprovalPutV2>>,
    TError,
    { data: BodyType<MassSendForApprovalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsMassSendForApprovalPutV2>>,
  TError,
  { data: BodyType<MassSendForApprovalRequest> },
  TContext
> => {
  const mutationKey = ["billsMassSendForApprovalPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsMassSendForApprovalPutV2>>,
    { data: BodyType<MassSendForApprovalRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsMassSendForApprovalPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsMassSendForApprovalPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsMassSendForApprovalPutV2>>
>;
export type BillsMassSendForApprovalPutV2MutationBody =
  BodyType<MassSendForApprovalRequest>;
export type BillsMassSendForApprovalPutV2MutationError = ErrorType<unknown>;

export const useBillsMassSendForApprovalPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsMassSendForApprovalPutV2>>,
    TError,
    { data: BodyType<MassSendForApprovalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsMassSendForApprovalPutV2>>,
  TError,
  { data: BodyType<MassSendForApprovalRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsMassSendForApprovalPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsSplitByBillIdGetV2 = (
  billId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SplitBillResponse>(
    { url: `/apix/v2/Bills/${billId}/split`, method: "GET", signal },
    options,
  );
};

export const getBillsSplitByBillIdGetV2QueryKey = (billId?: number) => {
  return [`/apix/v2/Bills/${billId}/split`] as const;
};

export const getBillsSplitByBillIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  billId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillsSplitByBillIdGetV2QueryKey(billId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>
  > = ({ signal }) => billsSplitByBillIdGetV2(billId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!billId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillsSplitByBillIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>
>;
export type BillsSplitByBillIdGetV2QueryError = ErrorType<ForbiddenResponse>;

export function useBillsSplitByBillIdGetV2<
  TData = Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  billId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof billsSplitByBillIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillsSplitByBillIdGetV2QueryOptions(billId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsSplitByBillIdPostV2 = (
  billId: number,
  splitBillRequest: BodyType<SplitBillRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SplitBillResponse>(
    {
      url: `/apix/v2/Bills/${billId}/split`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: splitBillRequest,
      signal,
    },
    options,
  );
};

export const getBillsSplitByBillIdPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ConflictResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsSplitByBillIdPostV2>>,
    TError,
    { billId: number; data: BodyType<SplitBillRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsSplitByBillIdPostV2>>,
  TError,
  { billId: number; data: BodyType<SplitBillRequest> },
  TContext
> => {
  const mutationKey = ["billsSplitByBillIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsSplitByBillIdPostV2>>,
    { billId: number; data: BodyType<SplitBillRequest> }
  > = (props) => {
    const { billId, data } = props ?? {};

    return billsSplitByBillIdPostV2(billId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsSplitByBillIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsSplitByBillIdPostV2>>
>;
export type BillsSplitByBillIdPostV2MutationBody = BodyType<SplitBillRequest>;
export type BillsSplitByBillIdPostV2MutationError = ErrorType<
  BadRequestResponse | ConflictResponse
>;

export const useBillsSplitByBillIdPostV2 = <
  TError = ErrorType<BadRequestResponse | ConflictResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsSplitByBillIdPostV2>>,
    TError,
    { billId: number; data: BodyType<SplitBillRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsSplitByBillIdPostV2>>,
  TError,
  { billId: number; data: BodyType<SplitBillRequest> },
  TContext
> => {
  const mutationOptions = getBillsSplitByBillIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsSplitByBillIdPutV2 = (
  billId: number,
  editSplitBillRequest: BodyType<EditSplitBillRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SplitBillResponse>(
    {
      url: `/apix/v2/Bills/${billId}/split`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: editSplitBillRequest,
    },
    options,
  );
};

export const getBillsSplitByBillIdPutV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ConflictResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsSplitByBillIdPutV2>>,
    TError,
    { billId: number; data: BodyType<EditSplitBillRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsSplitByBillIdPutV2>>,
  TError,
  { billId: number; data: BodyType<EditSplitBillRequest> },
  TContext
> => {
  const mutationKey = ["billsSplitByBillIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsSplitByBillIdPutV2>>,
    { billId: number; data: BodyType<EditSplitBillRequest> }
  > = (props) => {
    const { billId, data } = props ?? {};

    return billsSplitByBillIdPutV2(billId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsSplitByBillIdPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsSplitByBillIdPutV2>>
>;
export type BillsSplitByBillIdPutV2MutationBody =
  BodyType<EditSplitBillRequest>;
export type BillsSplitByBillIdPutV2MutationError = ErrorType<
  BadRequestResponse | ConflictResponse
>;

export const useBillsSplitByBillIdPutV2 = <
  TError = ErrorType<BadRequestResponse | ConflictResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsSplitByBillIdPutV2>>,
    TError,
    { billId: number; data: BodyType<EditSplitBillRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsSplitByBillIdPutV2>>,
  TError,
  { billId: number; data: BodyType<EditSplitBillRequest> },
  TContext
> => {
  const mutationOptions = getBillsSplitByBillIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const billsReleaseRetainagePostV2 = (
  releaseRetainageRequest: BodyType<ReleaseRetainageRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ReleaseRetainageResponse>(
    {
      url: `/apix/v2/Bills/release-retainage`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: releaseRetainageRequest,
      signal,
    },
    options,
  );
};

export const getBillsReleaseRetainagePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsReleaseRetainagePostV2>>,
    TError,
    { data: BodyType<ReleaseRetainageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billsReleaseRetainagePostV2>>,
  TError,
  { data: BodyType<ReleaseRetainageRequest> },
  TContext
> => {
  const mutationKey = ["billsReleaseRetainagePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billsReleaseRetainagePostV2>>,
    { data: BodyType<ReleaseRetainageRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billsReleaseRetainagePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillsReleaseRetainagePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof billsReleaseRetainagePostV2>>
>;
export type BillsReleaseRetainagePostV2MutationBody =
  BodyType<ReleaseRetainageRequest>;
export type BillsReleaseRetainagePostV2MutationError = ErrorType<unknown>;

export const useBillsReleaseRetainagePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billsReleaseRetainagePostV2>>,
    TError,
    { data: BodyType<ReleaseRetainageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billsReleaseRetainagePostV2>>,
  TError,
  { data: BodyType<ReleaseRetainageRequest> },
  TContext
> => {
  const mutationOptions =
    getBillsReleaseRetainagePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `Testing`


**Stability Level**: `draft`
 * @summary Processes a bill file through OCR, vendor matching, and LLM parsing without persistence.
This endpoint is designed for testing and evaluation of the bill processing algorithm.
 */
export const testingBillsProcessPostV2 = (
  billProcessingRequest: BodyType<BillProcessingRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BillProcessingResponse>(
    {
      url: `/apix/v2/testing/Bills/process`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: billProcessingRequest,
      signal,
    },
    options,
  );
};

export const getTestingBillsProcessPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingBillsProcessPostV2>>,
    TError,
    { data: BodyType<BillProcessingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testingBillsProcessPostV2>>,
  TError,
  { data: BodyType<BillProcessingRequest> },
  TContext
> => {
  const mutationKey = ["testingBillsProcessPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testingBillsProcessPostV2>>,
    { data: BodyType<BillProcessingRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testingBillsProcessPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestingBillsProcessPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof testingBillsProcessPostV2>>
>;
export type TestingBillsProcessPostV2MutationBody =
  BodyType<BillProcessingRequest>;
export type TestingBillsProcessPostV2MutationError =
  ErrorType<BadRequestResponse>;

/**
 * @summary Processes a bill file through OCR, vendor matching, and LLM parsing without persistence.
This endpoint is designed for testing and evaluation of the bill processing algorithm.
 */
export const useTestingBillsProcessPostV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingBillsProcessPostV2>>,
    TError,
    { data: BodyType<BillProcessingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testingBillsProcessPostV2>>,
  TError,
  { data: BodyType<BillProcessingRequest> },
  TContext
> => {
  const mutationOptions = getTestingBillsProcessPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
